/* Fit Frenzy Oct 2026: behaviour for the landing page and the connected collection pages.
   - Hero deal cycler with an odometer saving, scroll scenes (marquee band, manifesto, split, category fan) driven by
     one rAF loop on native scrolling; GSAP only animates the product swaps. The opening and entrances are CSS.
   - Quick add posts to /cart/add.js and opens the theme's own cart drawer (same mechanism as the 2026 set pages).
   - Countdown and day lines follow the sale window in AEDT. Preview themes accept ?ffday=pre|vip|thu|fri|sat|sun|over.
   No internal notes are written to the page. */
(function () {
  'use strict';
  var D = document, H = D.documentElement, W = window;
  if (W.__ff26) return; W.__ff26 = true;
  var cfg = {};
  try { cfg = JSON.parse(D.getElementById('ff26-cfg').textContent); } catch (e) {}
  var RM = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = W.matchMedia('(pointer: fine)').matches;
  var G = W.gsap, ST = W.ScrollTrigger, hasG = !!G;
  if (G && ST) G.registerPlugin(ST);
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || cfg.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var roots = $$('[data-ff26-root]');
  function track(ev, data) { try { (W.dataLayer = W.dataLayer || []).push(Object.assign({ event: 'ff26_' + ev }, data || {})); } catch (e) {} }

  /* ---------- Header offsets ---------- */
  function headerH() {
    var h = 0;
    $$('header, .header, [class*="header"], .announcement-bar, [class*="announcement"]').forEach(function (e) {
      if (e.closest('.ff26')) return;
      var cs = getComputedStyle(e);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && e.offsetHeight > 0 && e.offsetHeight < 260) {
        var r = e.getBoundingClientRect();
        if (r.top <= 2 && r.bottom > h) h = r.bottom;
      }
    });
    return Math.round(h);
  }
  function setOffsets() {
    var hdr = headerH(), first = roots[0], top0 = 0;
    if (first) top0 = Math.max(0, Math.round(first.getBoundingClientRect().top + W.scrollY));
    roots.concat($$('.ff26-pre')).forEach(function (r) { r.style.setProperty('--hdr', hdr + 'px'); r.style.setProperty('--top0', Math.min(top0, 220) + 'px'); });
  }
  setOffsets();
  // Safari's toolbar collapsing mid-scroll fires resize on phones: only re-measure on a real width change (rotation)
  var offW = W.innerWidth;
  W.addEventListener('resize', function () { if (FINE || W.innerWidth !== offW) { offW = W.innerWidth; setOffsets(); } });
  W.addEventListener('load', setOffsets);

  /* ---------- Podium's "Got questions?" greeting waits ----------
     On phones it sat over the hero buttons and the deal cards (Brandon, 7 Oct). On Fit Frenzy pages the greeting
     (#podium-prompt) stays hidden until 45s into the visit, counted from the first Fit Frenzy page in the session;
     the Text us button (#podium-bubble) shows as normal. The hiding is CSS (ff26.css), so it's in place before
     Podium loads; this only lifts it. On a preview theme ?chatdelay=<seconds> shortens the wait for testing. */
  (function () {
    var KEY = 'ff26chat', delay = 45000, t0 = Date.now();
    var qd = new URLSearchParams(location.search).get('chatdelay');
    if (cfg.review && qd !== null && !isNaN(+qd)) delay = +qd * 1000;
    try { var s = +sessionStorage.getItem(KEY); if (s && Date.now() - s < 6 * 3600e3) t0 = s; else sessionStorage.setItem(KEY, t0); } catch (e) {}
    setTimeout(function () { H.classList.add('ff26-chat-ok'); }, Math.max(0, delay - (Date.now() - t0)));
  })();

  /* ---------- Sale phase, day lines, countdown ---------- */
  var T = { vip: Date.parse(cfg.vip || '2026-10-07T00:00:00+11:00'), start: Date.parse(cfg.start || '2026-10-08T00:00:00+11:00'), end: Date.parse(cfg.end || '2026-10-11T23:59:59+11:00') };
  var q = new URLSearchParams(location.search), skew = 0;
  var SIM = { vip: '2026-10-07T10:00:00+11:00', thu: '2026-10-08T09:00:00+11:00', fri: '2026-10-09T09:00:00+11:00', sat: '2026-10-10T09:00:00+11:00', sun: '2026-10-11T17:30:00+11:00', final: '2026-10-11T21:00:00+11:00', over: '2026-10-12T09:00:00+11:00' };
  if (cfg.review && SIM[q.get('ffday')]) skew = Date.parse(SIM[q.get('ffday')]) - Date.now();
  function now() { return Date.now() + skew; }
  function phase(t) {
    if (t < T.vip) return 'pre';
    if (t < T.start) return 'vip';
    if (t > T.end) return 'over';
    var d = new Date(t + 11 * 3600e3).getUTCDate();
    return ({ 8: 'thu', 9: 'fri', 10: 'sat', 11: 'sun' })[d] || 'thu';
  }
  var DAY = { pre: 'Starts Thursday!', vip: 'Early access!', thu: 'It’s on!', fri: '3 days left!', sat: '2 days left!', sun: 'Ends tonight!', over: 'That’s a wrap!' };
  var LAB = { pre: 'Starts in', vip: 'Opens to all in', thu: 'Ends in', fri: 'Ends in', sat: 'Ends in', sun: 'Ends tonight in', over: 'Fit Frenzy has ended' };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var t = now(), ph = phase(t), target = (ph === 'pre' || ph === 'vip') ? T.start : T.end, left = Math.max(0, target - t);
    var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    // The last 6 hours of the sale: "Final hours!" and the countdowns turn orange (html data-final)
    var fin = /^(thu|fri|sat|sun)$/.test(ph) && left < 6 * 3600e3, dayT = fin ? 'Final hours!' : DAY[ph], labT = fin ? 'Final hours! Ends in' : LAB[ph];
    roots.forEach(function (r) { if (r.dataset.phase !== ph) r.dataset.phase = ph; if (fin !== r.hasAttribute('data-final')) r.toggleAttribute('data-final', fin); });
    $$('[data-day]').forEach(function (e) { if (e.textContent !== dayT) e.textContent = dayT; });
    $$('[data-cd-lab]').forEach(function (e) { if (e.textContent !== labT) e.textContent = labT; });
    var txt = ph === 'over' ? '' : (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    $$('[data-cd-t]').forEach(function (e) { e.textContent = txt; });
    $$('[data-clock]').forEach(function (c) {
      c.style.visibility = ph === 'over' ? 'hidden' : '';
      var u = { d: d, h: h, m: m, s: sec };
      $$('[data-u]', c).forEach(function (b) { var v = pad(u[b.dataset.u]); if (b.textContent !== v) b.textContent = v; });
    });
    $$('[data-cd-lab2]').forEach(function (e) {
      if (!e.dataset.orig) e.dataset.orig = e.textContent;
      e.textContent = ph === 'pre' || ph === 'vip' ? 'Starts Thursday 8 October' : ph === 'over' ? 'Fit Frenzy has ended' : e.dataset.orig;
    });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- Odometer ---------- */
  function odoBuild(el, str, from0) {
    el.innerHTML = '';
    var w = D.createElement('span'); w.className = 'odo';
    str.split('').forEach(function (ch, i) {
      if (/\d/.test(ch)) {
        var col = D.createElement('span'); col.className = 'odo__d';
        for (var k = 0; k < 10; k++) { var s = D.createElement('span'); s.textContent = k; col.appendChild(s); }
        col.dataset.v = ch;
        col.style.transform = 'translateY(' + (from0 ? 0 : -ch) + 'em)';
        col.style.transitionDelay = (i * 0.06) + 's';
        w.appendChild(col);
      } else { var c = D.createElement('span'); c.className = 'odo__c'; c.textContent = ch; w.appendChild(c); }
    });
    el.appendChild(w);
    if (from0) { void w.offsetWidth; $$('.odo__d', w).forEach(function (c) { c.style.transform = 'translateY(' + (-c.dataset.v) + 'em)'; }); }
  }
  function odo(el, str) {
    if (!el) return;
    var prev = el.dataset.v || '';
    el.dataset.v = str; el.setAttribute('aria-label', str);
    if (RM) { el.textContent = str; return; }
    if (!prev || prev.length !== str.length || !$('.odo', el)) { odoBuild(el, str, true); return; }
    var cols = $$('.odo__d', el), di = 0;
    str.split('').forEach(function (ch) { if (/\d/.test(ch)) { var c = cols[di++]; if (c) { c.dataset.v = ch; c.style.transform = 'translateY(' + (-ch) + 'em)'; } } });
  }

  /* ---------- Hero ---------- */
  var heroApi = null;
  function hero() {
    var r = $('[data-hero]'); if (!r) return;
    var slides = $$('[data-slide]', r), dots = $$('[data-dot]', r);
    var amt = $('[data-odo]', r), name = $('[data-name]', r), shop = $('[data-shop]', r), wrap = $('[data-save-wrap]', r);
    var dur = parseInt(r.dataset.autoMs, 10) || (parseInt(r.dataset.auto, 10) || 4) * 1000, i = 0, t0 = 0, paused = false, inView = true, started = false, raf = 0;
    function info(n) {
      var s = slides[n], d = s.dataset;
      wrap.style.visibility = d.hasSave ? '' : 'hidden';
      if (d.hasSave) odo(amt, d.save);
      name.innerHTML = '<b></b> <span></span>';
      name.firstChild.textContent = d.title;
      name.lastChild.textContent = d.was ? d.now + ', was ' + d.was : d.now;
      shop.href = s.getAttribute('href');
    }
    function enter(s, wait) {
      s.classList.remove('is-out');
      if (!hasG || RM) return;
      var img = $('.slide__img', s), tag = $('.tagw', s), sh = $('.slide__sh', s), w = wait || 0;
      G.killTweensOf([img, tag, sh]);
      G.fromTo(img, { x: 70, opacity: 0, scale: .97 }, { x: 0, opacity: 1, scale: 1, duration: .85, ease: 'expo.out', delay: w });
      if (sh) G.fromTo(sh, { opacity: 0, scaleX: .4 }, { opacity: 1, scaleX: 1, duration: .85, ease: 'expo.out', delay: w });
      if (tag) G.fromTo(tag, { rotation: -42, opacity: 0, y: -30 }, { rotation: -7, opacity: 1, y: 0, duration: 1.2, ease: 'elastic.out(1,.45)', delay: w + .3 });
    }
    function leave(s) {
      if (!hasG || RM) { s.classList.remove('is-on'); return; }
      var img = $('.slide__img', s), tag = $('.tagw', s);
      var sh = $('.slide__sh', s);
      s.classList.add('is-out'); G.killTweensOf([img, tag, sh]);
      if (tag) G.to(tag, { y: -24, rotation: -20, opacity: 0, duration: .2, ease: 'power2.in' });
      if (sh) G.to(sh, { opacity: 0, duration: .3, ease: 'power2.in' });
      G.to(img, { x: -60, opacity: 0, duration: .3, ease: 'power2.in', onComplete: function () { s.classList.remove('is-out'); if (s !== slides[i]) s.classList.remove('is-on'); G.set([img, tag], { clearProps: 'x,y' }); } });
    }
    function go(n, user) {
      if (n === i && started) return;
      var prev = slides[i]; i = (n + slides.length) % slides.length;
      H.classList.add('ff26-sw');
      if (prev && prev !== slides[i]) leave(prev);
      slides[i].classList.add('is-on');
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); var b = d.firstChild; if (b) b.style.transform = 'scaleX(' + (k < i ? 1 : 0) + ')'; });
      info(i); enter(slides[i], prev && prev !== slides[i] ? .24 : 0); t0 = performance.now(); started = true;
      if (user) track('hero_deal', { deal: slides[i].dataset.title });
    }
    function loop(ts) {
      raf = requestAnimationFrame(loop);
      if (paused || !inView || RM || D.hidden) { t0 = ts - (dots[i] && dots[i].__p || 0) * dur; return; }
      var p = clamp((ts - t0) / dur, 0, 1); if (dots[i]) { dots[i].__p = p; var bar = dots[i].firstChild; if (bar) bar.style.transform = 'scaleX(' + p + ')'; }
      if (p >= 1) { if (dots[i]) dots[i].__p = 0; go(i + 1); }
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k, true); }); });
    // The deals keep cycling under a resting mouse (Brandon, 6 Oct). Only keyboard focus inside the hero pauses it, so
    // someone tabbing through can read a deal; a mouse click on a dot or button doesn't stop the cycle.
    r.addEventListener('focusin', function (e) { try { if (e.target.matches(':focus-visible')) paused = true; } catch (x) {} });
    r.addEventListener('focusout', function () { paused = false; });
    // swipe on phones
    var sx = null;
    r.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    r.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1), true); sx = null; }, { passive: true });
    if ('IntersectionObserver' in W) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }).observe(r);
    // parallax on desktop
    if (FINE && !RM) {
      var ghost = $('[data-ghost]', r), mx = 0, my = 0, cx = 0, cy = 0;
      r.addEventListener('mousemove', function (e) { var b = r.getBoundingClientRect(); mx = (e.clientX - b.left) / b.width * 2 - 1; my = (e.clientY - b.top) / b.height * 2 - 1; });
      (function par() { requestAnimationFrame(par); cx += (mx - cx) * .07; cy += (my - cy) * .07; var s = slides[i]; if (s) { var p = $('.slide__p', s); if (p) p.style.transform = 'translate(' + (cx * -14).toFixed(2) + 'px,' + (cy * -8).toFixed(2) + 'px)'; } if (ghost) ghost.style.translate = (cx * 30).toFixed(2) + 'px ' + (cy * 10).toFixed(2) + 'px'; })();
    }
    heroApi = {
      start: function () {
        if (!slides.length) return;
        info(0);
        // The first deal's entrance is CSS (after the opening); the cycle starts once it has landed.
        var pre = (H.classList.contains('ff26-anim') && !H.classList.contains('ff26-nopre')) ? Math.max(0, 1450 + 1200 - performance.now()) : 0;
        t0 = performance.now() + pre; started = true;
        if (!raf) raf = requestAnimationFrame(loop);
      }
    };
    if (slides[0] && slides[0].dataset.hasSave) { amt.dataset.v = ''; odoBuild(amt, slides[0].dataset.save, false); amt.dataset.v = slides[0].dataset.save; }
  }


  /* ---------- Opening ----------
     The preloader and hero entrance are CSS, driven by the inline script in the hero section (html.ff26-in).
     Here we only start the deal cycler once the hero is in. */

  /* ---------- Scroll scenes (one rAF loop) ---------- */
  var scenes = [];
  function scene(el, fn) { if (!el) return; var s = { el: el, fn: fn, on: true }; scenes.push(s); if ('IntersectionObserver' in W) new IntersectionObserver(function (es) { s.on = es[0].isIntersecting; }, { rootMargin: '20% 0px' }).observe(el); }
  var vh = W.innerHeight, vhW = W.innerWidth; W.addEventListener('resize', function () { if (FINE || W.innerWidth !== vhW) { vhW = W.innerWidth; vh = W.innerHeight; } });
  (function frame(ts) { requestAnimationFrame(frame); for (var k = 0; k < scenes.length; k++) { var s = scenes[k]; if (s.on) s.fn(s.el.getBoundingClientRect(), ts || 0); } })();

  // Marquee band: rows drift and run with the scroll; the card steps through the price slashes.
  (function () {
    var s = $('[data-mq]'); if (!s) return;
    var rows = $$('[data-mq-row]', s), card = $('[data-mq-card]', s), beats = $$('[data-beat]', s), count = $('[data-mq-count]', s), n = beats.length, cur = -1, lastY = W.scrollY, vel = 0, drift = 0;
    rows.forEach(function (r) { r.__w = (r.scrollWidth / 4) || 1; });
    W.addEventListener('resize', function () { rows.forEach(function (r) { r.__w = (r.scrollWidth / 4) || 1; }); });
    function setBeat(k) {
      if (k === cur) return;
      var prev = beats[cur]; cur = k;
      beats.forEach(function (b, j) { b.classList.toggle('is-on', j === k); b.classList.remove('is-prev'); });
      if (prev) { prev.classList.add('is-prev'); clearTimeout(prev.__t); prev.__t = setTimeout(function () { prev.classList.remove('is-prev'); }, 900); }
      if (count) count.textContent = pad(k + 1) + ' / ' + pad(n);
    }
    var cr = null, cs = null, ph = false;
    scene(s, function (r) {
      var span = r.height - vh, p = span > 0 ? clamp(-r.top / span, 0, 1) : 0;
      var y = W.scrollY; vel = vel * .85 + (y - lastY) * .15; lastY = y; drift += RM ? 0 : .6 + Math.abs(vel) * .35;
      rows.forEach(function (row) { var dir = parseFloat(row.dataset.mqRow) || 1, w = row.__w, x = ((drift + p * w * 1.4) * Math.abs(dir)) % w; row.style.transform = 'translate3d(' + (dir < 0 ? -x : x - w).toFixed(1) + 'px,0,0)'; });
      var isPh = W.innerWidth <= 820;
      if (isPh !== ph) { ph = isPh; s.classList.toggle('mq--timed', ph); beats.forEach(function (b) { $$('[data-strike],[data-now],[data-off]', b).forEach(function (e) { e.removeAttribute('style'); }); }); }
      if (n) {
        var raw = p * n, k = Math.min(n - 1, Math.floor(raw * .9999));
        if (cur >= 0 && k !== cur && raw > cur - .06 && raw < cur + 1.06) k = cur;
        setBeat(k);
      }
      if (n && !ph) {
        var lt = clamp(p * n - k, 0, 1);
        var b = beats[k], path = $('[data-strike]', b), nw = $('[data-now]', b), off = $('[data-off]', b);
        if (path) path.style.strokeDasharray = '1', path.style.strokeDashoffset = (1 - clamp((lt - .08) / .32, 0, 1)).toFixed(3);
        var pop = clamp((lt - .36) / .14, 0, 1);
        if (nw) { nw.style.transform = 'scale(' + (.6 + .4 * ease(pop)) + ')'; nw.style.opacity = pop; nw.style.transformOrigin = '0 100%'; }
        if (off) { off.style.transform = 'rotate(-3deg) translateY(' + ((1 - ease(clamp((lt - .46) / .14, 0, 1))) * 20) + 'px)'; off.style.opacity = clamp((lt - .46) / .14, 0, 1); }
      }
      if (card && !RM) {
        var e = ease(clamp(p * 1.6, 0, 1)), tr = -5 + 7 * p, ts = .8 + .2 * e;
        if (cr === null) { cr = tr; cs = ts; } else { cr += (tr - cr) * .16; cs += (ts - cs) * .16; }
        card.style.transform = 'rotate(' + cr.toFixed(2) + 'deg) scale(' + cs.toFixed(3) + ')';
      }
    });
  })();

  // Manifesto: words light up in reading order; the orange stroke draws at the end.
  (function () {
    var s = $('[data-mf]'); if (!s) return;
    var words = $$('.w', s), sig = $('[data-sig]', s), n = words.length;
    if (sig) { sig.style.strokeDasharray = '1'; sig.style.strokeDashoffset = '1'; }
    scene(s, function (r) {
      var p = clamp((vh * .82 - r.top) / (r.height * .78), 0, 1);
      for (var k = 0; k < n; k++) { var o = clamp(p * (n + 3) - k, 0, 1); words[k].style.opacity = (.12 + .88 * o).toFixed(3); }
      if (sig) sig.style.strokeDashoffset = (1 - clamp((p - .78) / .2, 0, 1)).toFixed(3);
    });
  })();

  // Where do you train: the two panels drift in from their own sides as the section arrives (desktop).
  (function () {
    var s = $('[data-sp]'); if (!s || RM) return;
    var panels = $$('[data-sp-p]', s);
    scene(s, function (r) {
      if (W.innerWidth <= 820) { panels.forEach(function (p) { p.style.transform = ''; }); return; }
      var p = ease(clamp((vh - r.top) / (vh * .8), 0, 1));
      panels.forEach(function (el) { var d = parseFloat(el.dataset.spP); el.style.transform = 'translateX(' + (d * (1 - p) * 7).toFixed(2) + '%)'; });
    });
  })();

  // Category fan: stacked cards spread into an arc (desktop); a swipe row on phones.
  (function () {
    var s = $('[data-fan]'); if (!s) return;
    var cards = $$('[data-fan-c]', s), n = cards.length, c = (n - 1) / 2;
    scene(s, function (r) {
      if (W.innerWidth <= 820) return;
      var p = ease(clamp((vh - r.top) / (vh * .75), 0, 1)), w = cards[0] ? cards[0].offsetWidth : 300;
      cards.forEach(function (el, k) {
        var o = k - c, rot = o * 5 * p + (1 - p) * (o * 1.5), x = o * w * .92 * p, y = Math.abs(o) * Math.abs(o) * 12 * p + (1 - p) * 40;
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + rot.toFixed(2) + 'deg)';
        el.style.zIndex = 10 - Math.abs(Math.round(o));
      });
    });
  })();

  // Hero: the ghost word slides and the stage drifts as you scroll away.
  (function () {
    var r0 = $('[data-hero]'); if (!r0 || RM) return;
    var stage = $('[data-stage]', r0), ghost = $('[data-ghost]', r0);
    scene(r0, function (r) { var p = clamp(-r.top / r.height, 0, 1); if (stage) stage.style.transform = 'translateY(' + (p * -50).toFixed(1) + 'px) scale(' + (1 + p * .05).toFixed(3) + ')'; if (ghost) ghost.style.marginLeft = (-p * 14).toFixed(2) + 'vw'; });
  })();

  /* ---------- Reveal on enter ---------- */
  (function () {
    var els = $$('.ff26 [data-rv]');
    if (!('IntersectionObserver' in W) || RM) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { if (e.target.parentElement && e.target.parentElement.__on) { e.target.classList.add('is-in'); io.unobserve(e.target); return; } var el = e.target, sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0; el.style.transitionDelay = ((sib % 4) * 0.07) + 's'; el.classList.add('is-in'); io.unobserve(el); } });
    }, { rootMargin: '0px 0px 4% 0px' });
    els.forEach(function (e) { io.observe(e); });
  })();

  // Card image parallax on desktop.
  if (FINE && !RM) D.addEventListener('mousemove', function (e) {
    var c = e.target.closest && e.target.closest('.pc'); if (!c) return;
    var m = $('.pc__media img', c); if (!m) return;
    var b = c.getBoundingClientRect(), nx = (e.clientX - b.left) / b.width - .5, ny = (e.clientY - b.top) / b.height - .5;
    m.style.translate = (nx * -10).toFixed(1) + 'px ' + (ny * -8).toFixed(1) + 'px';
  });

  /* ---------- Cart: quick add + theme drawer ---------- */
  function openDrawer() {
    return fetch(ROOT + '?sections=' + encodeURIComponent(cfg.drawerSection || 'header-new'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var tmp = D.createElement('div'); tmp.innerHTML = sections[cfg.drawerSection || 'header-new'] || '';
        var fresh = tmp.querySelector('#cart-drawer'), drawer = D.getElementById('cart-drawer');
        if (!fresh || !drawer) throw new Error('no drawer');
        drawer.innerHTML = fresh.innerHTML;
        var counts = tmp.querySelectorAll('.cart-count'); if (counts.length) { var t = counts[0].textContent.trim(); $$('.cart-count').forEach(function (n) { n.textContent = t; }); }
        drawer.classList.add('cart-summary--open');
        D.body.classList.add('cart-open', 'no-scroll');
        var ov = $('.cart-summary__overlay'); if (ov) ov.classList.add('cart-overlay--open');
        var close = function () { drawer.classList.remove('cart-summary--open'); D.body.classList.remove('cart-open', 'no-scroll'); var o = $('.cart-summary__overlay'); if (o) o.classList.remove('cart-overlay--open'); };
        $$('.js-close-cart-icon').forEach(function (b) { b.addEventListener('click', close); });
        var oc = $('.js-close-cart-overlay'); if (oc) oc.addEventListener('click', close);
      })
      .catch(function () { var icon = $('.js-cart-icon'); if (icon) icon.click(); else location.href = ROOT + 'cart'; });
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ff26-add]'); if (!b) return;
    e.preventDefault();
    var card = b.closest('[data-pc]'), note = card && $('.pc__added', card);
    if (card) card.classList.add('is-adding');
    fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.dataset.ff26Add, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add this item'); return j; }); })
      .then(function () {
        track('add_to_cart', { item: b.dataset.title, variant: b.dataset.ff26Add });
        if (note) { note.textContent = 'Added to cart'; card.classList.add('is-added'); setTimeout(function () { card.classList.remove('is-added'); }, 2200); }
        meter(); return openDrawer();
      })
      .catch(function (err) { if (note) { note.textContent = err.message; card.classList.add('is-added'); setTimeout(function () { card.classList.remove('is-added'); }, 3500); } })
      .then(function () { if (card) card.classList.remove('is-adding'); });
  });

  /* ---------- Gift meter ---------- */
  var gifts = $('[data-gifts]');
  function money(c, cur) { try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur || 'AUD', maximumFractionDigits: 0 }).format(c / 100); } catch (e) { return '$' + Math.round(c / 100); } }
  function meter() {
    if (!gifts) return;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var t = (gifts.dataset.t || '69900,149900,299900').split(',').map(Number), tot = c.total_price || 0, cur = c.currency;
      var msg, k = t.filter(function (x) { return tot >= x; }).length;
      if (!c.item_count) msg = $('[data-meter-msg]', gifts).dataset.empty || $('[data-meter-msg]', gifts).textContent;
      else if (k === 0) msg = 'Spend ' + money(t[0] - tot, cur) + ' more to pick a free gift.';
      else if (k === 1) msg = 'You’ve unlocked a free gift. Spend ' + money(t[1] - tot, cur) + ' more for the over-$1,499 choices.';
      else if (k === 2) msg = 'You’ve unlocked the over-$1,499 gifts. Spend ' + money(t[2] - tot, cur) + ' more for a gift kit.';
      else msg = 'You’ve unlocked the top tier: pick a gift kit.';
      var m = $('[data-meter-msg]', gifts); if (m) { if (!m.dataset.empty) m.dataset.empty = m.textContent; m.textContent = msg; }
      var pos = tot <= t[0] ? tot / t[0] * 23.3 : tot <= t[1] ? 23.3 + (tot - t[0]) / (t[1] - t[0]) * 26.7 : 50 + clamp((tot - t[1]) / (t[2] - t[1]), 0, 1) * 50;
      var f = $('[data-meter-fill]', gifts); if (f) f.style.width = clamp(pos, 0, 100) + '%';
      $$('[data-tier]', gifts).forEach(function (el) { el.classList.toggle('is-hit', tot >= +el.dataset.tier); });
    }).catch(function () {});
  }
  meter();
  D.addEventListener('visibilitychange', function () { if (!D.hidden) meter(); });


  /* ---------- Swipe rows that tilt like a hand of cards ---------- */
  function tilt(row) {
    if (!row || row.__tilt) return; row.__tilt = 1;
    var kids = function () { return Array.prototype.filter.call(row.children, function (k) { return !k.hidden; }); };
    function upd() {
      var ks = kids();
      var ox = getComputedStyle(row).overflowX;
      if (RM || W.innerWidth > 820 || (ox !== 'auto' && ox !== 'scroll') || row.scrollWidth <= row.clientWidth + 4) { if (row.__on) { row.__on = 0; ks.forEach(function (k) { k.style.transform = ''; k.classList.remove('is-cur'); }); } return; }
      row.__on = 1;
      var rc = row.getBoundingClientRect(), cx = rc.left + Math.min(rc.width * .5, 200), best = null, bd = 9;
      ks.forEach(function (k) {
        var r = k.getBoundingClientRect(), d = clamp(((r.left + r.width / 2) - cx) / (r.width || 1), -1.6, 1.6);
        k.style.transform = 'translateY(' + (Math.abs(d) * 14).toFixed(1) + 'px) rotate(' + (d * 3.2).toFixed(2) + 'deg) scale(' + (1 - Math.abs(d) * .04).toFixed(3) + ')';
        k.style.transitionDelay = '0s';
        k.classList.add('is-in');
        if (Math.abs(d) < bd) { bd = Math.abs(d); best = k; }
      });
      // The card in front gets the same little swing every time (tag swings, product settles), not only the one a finger touched
      ks.forEach(function (k) { k.classList.toggle('is-cur', k === best && bd < .5); });
    }
    // Load the row's photos as the row comes near, so cards aren't blank while they're swiped in
    if ('IntersectionObserver' in W) {
      var pio = new IntersectionObserver(function (es) { if (!es[0].isIntersecting) return; $$('img[loading="lazy"]', row).forEach(function (im) { im.loading = 'eager'; }); pio.disconnect(); }, { rootMargin: '100% 0px' });
      pio.observe(row);
    }
    var q = 0; row.addEventListener('scroll', function () { if (!q) { q = requestAnimationFrame(function () { q = 0; upd(); }); } }, { passive: true });
    W.addEventListener('resize', upd); upd(); setTimeout(upd, 600);
  }
  $$('[data-tilt]').forEach(tilt);

  /* ---------- Gifts strip (only when the gift section is on the page) ---------- */
  function giftStrip() {
    var gs = $('[data-gifts]'); if (!gs) return null;
    var a = D.createElement('a'); a.className = 'gs'; a.href = '#ff26-gifts';
    a.innerHTML = '<span class="gs__t x">Over $699?<br><span class="acc acc--ink sl">Pick a free gift.</span></span><span class="gs__imgs"></span><span class="gs__go">See the gifts<svg class="chev" viewBox="0 0 163.67 129.93" aria-hidden="true"><polygon points="34.42,37.1 103.11,64.3 103.11,64.8 34.42,91.13 34.42,117.09 131.06,76.23 131.06,55.23 34.42,11.26"/></svg></span>';
    $$('[data-tier="69900"] img', gs).slice(0, 4).forEach(function (i) { var c = i.cloneNode(); c.loading = 'lazy'; a.querySelector('.gs__imgs').appendChild(c); });
    return a;
  }
  $$('[data-gift-slot]').forEach(function (slot) { var s = giftStrip(); if (s) slot.appendChild(s); });

  /* ---------- Shelves: best savings first, pre-orders last ---------- */
  $$('[data-shelf]').forEach(function (row) {
    var end = $('.shelf__end', row), cs = $$('.pc', row);
    cs.sort(function (a, b) { var la = a.hasAttribute('data-late') ? 1 : 0, lb = b.hasAttribute('data-late') ? 1 : 0; return (la - lb) || (+b.dataset.save - +a.dataset.save) || (+a.dataset.i - +b.dataset.i); });
    row.style.scrollSnapType = 'none';
    cs.forEach(function (c, i) { c.hidden = i >= 8; row.insertBefore(c, end); });
    row.scrollLeft = 0;
    requestAnimationFrame(function () { row.scrollLeft = 0; row.style.scrollSnapType = ''; });
  });

  /* ---------- Where do you train: phone switch ---------- */
  (function () {
    var s = $('[data-sp]'); if (!s) return;
    var tabs = $$('[data-sp-tab]', s), ps = $$('.sp__p', s), cur = 0;
    function show(i) {
      if (i === cur) return; var prev = ps[cur]; cur = i;
      ps.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.classList.remove('is-prev'); });
      if (prev) { prev.classList.add('is-prev'); setTimeout(function () { prev.classList.remove('is-prev'); }, 750); }
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); track('split_tab', { tab: k }); }); });
    var sx = null, pn = $('[data-sp-panels]', s);
    if (pn) {
      pn.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      pn.addEventListener('touchend', function (e) { if (sx === null || W.innerWidth > 820) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(dx < 0 ? 1 : 0); sx = null; }, { passive: true });
    }
  })();

  /* ---------- The big ones: swipe counter ---------- */
  (function () {
    var row = $('[data-bd-grid]'), n = $('[data-bd-n]'); if (!row || !n) return;
    row.addEventListener('scroll', function () { var c = row.children[0]; if (!c) return; var i = Math.round(row.scrollLeft / (c.getBoundingClientRect().width + 12)) + 1; n.textContent = pad(Math.min(i, row.children.length)); }, { passive: true });
  })();

  /* ---------- Keep the sticky category rail under the theme header when it slides back in ---------- */
  (function () {
    var rail = $('[data-rail]'); if (!rail) return;
    var hs = $$('#header-new, #shopify-section-header-new, .shopify-section-group-header-group, [class*="sticky-header"], header');
    var last = -1, q = 0;
    function upd() {
      q = 0; var b = 0;
      hs.forEach(function (h) { var cs = getComputedStyle(h); if (cs.position !== 'fixed' && cs.position !== 'sticky') return; var r = h.getBoundingClientRect(); if (r.top <= 1 && r.bottom > b && r.height < 240) b = r.bottom; });
      b = Math.round(b); if (b !== last) { last = b; rail.style.top = b + 'px'; }
    }
    W.addEventListener('scroll', function () { if (!q) q = requestAnimationFrame(upd); }, { passive: true });
    upd();
  })();

  /* ---------- Collection grid: filter chips + sort ---------- */
  (function () {
    var g = $('[data-cg-grid]'); if (!g) return;
    var cards = $$('[data-pc]', g), chipsEl = $('[data-cg-chips]'), sortEl = $('[data-cg-sort]'), countEl = $('[data-cg-count]');
    function grp(c) {
      var s = ((c.dataset.type || '') + ' ' + (c.dataset.t || '')).toLowerCase();
      if (/sauna/.test(s)) return 'Saunas';
      if (/ice bath|plunge|chiller/.test(s)) return 'Ice baths';
      if (/boots|compression/.test(s)) return 'Recovery boots';
      if (/reformer|pilates/.test(s)) return 'Reformers';
      if (/stair|treadmill|spin|rower|cardio/.test(s)) return 'Cardio';
      if (/attachment|j-hook|safety|power arms|utility seat|spotter|pull up|monolift|handle for|pulley/.test(s)) return 'Rack add-ons';
      if (/holder|storage|gun rack/.test(s)) return 'Storage';
      if (/rack|rig/.test(s)) return 'Racks';
      if (/bench/.test(s)) return 'Benches';
      if (/machine|press|row|extension|multigym|station|crossover|functional trainer|hack squat|calf|fly|dip|sissy/.test(s)) return 'Machines';
      if (/barbell|trap bar|deadlift bar|squat bar|bent/.test(s)) return 'Bars';
      if (/plate/.test(s)) return 'Plates';
      if (/kettlebell|dumbbell/.test(s)) return 'Weights';
      return 'Accessories';
    }
    var counts = {}; cards.forEach(function (c) { c.__g = grp(c); counts[c.__g] = (counts[c.__g] || 0) + 1; });
    var groups = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    var active = 'all';
    // Ads can open a category pre-filtered: ?ffg=saunas, ?ffg=racks, ?ffg=ice-baths ...
    var want = (new URLSearchParams(location.search).get('ffg') || '').toLowerCase();
    if (want) groups.forEach(function (gname) { if (gname.toLowerCase().replace(/\s+/g, '-') === want) active = gname; });
    if (chipsEl && groups.length > 1) {
      var mk = function (label, val, n) { var b = D.createElement('button'); b.type = 'button'; b.className = 'chip'; b.dataset.v = val; b.setAttribute('aria-pressed', val === active ? 'true' : 'false'); b.textContent = label + (n ? ' (' + n + ')' : ''); chipsEl.appendChild(b); };
      mk('All', 'all', cards.length); groups.forEach(function (gname) { mk(gname, gname, counts[gname]); });
      chipsEl.addEventListener('click', function (e) { var b = e.target.closest('.chip'); if (!b) return; active = b.dataset.v; $$('.chip', chipsEl).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); apply(); track('filter', { group: active }); });
    } else if (chipsEl) chipsEl.remove();
    var collapse = g.dataset.collapse === 'auto' ? (W.innerWidth <= 820 ? 18 : 24) : parseInt(g.dataset.collapse || '0', 10), moreBtn = $('[data-cg-more]'), expanded = !collapse;
    var brkT = $$('template[data-brk]');
    function sortCards(list, mode) {
      return list.sort(function (a, b) {
        var ai = +a.dataset.i, bi = +b.dataset.i, la = a.hasAttribute('data-late') ? 1 : 0, lb = b.hasAttribute('data-late') ? 1 : 0;
        if (la !== lb) return la - lb;   // pre-order items always go last
        if (mode === 'save') return (+b.dataset.save - +a.dataset.save) || ai - bi;
        if (mode === 'low') return (+a.dataset.price - +b.dataset.price) || ai - bi;
        if (mode === 'high') return (+b.dataset.price - +a.dataset.price) || ai - bi;
        return ai - bi;
      });
    }
    // Break-up sections (feature card, category deck, countdown band) every few rows, so a long category never reads as a wall.
    function placeBreakers(visible) {
      $$('[data-brk-item]', g).forEach(function (e) { e.remove(); });
      if (!brkT.length) return;
      var per = W.innerWidth <= 820 ? 6 : (W.innerWidth <= 1100 ? 9 : 8);
      var order = ['ft', 'band', 'gifts', 'ft', 'cats', 'ft', 'band'], used = {}, n = 0;
      for (var k = 1; k * per < visible.length && n < order.length; k++, n++) {
        var type = order[n], node = null;
        if (type === 'ft') {
          var before = {}; visible.slice(0, k * per).forEach(function (c) { before[c.dataset.h] = 1; });
          var tpl = brkT.filter(function (x) { return x.dataset.brk === 'ft' && !used[x.dataset.h] && !before[x.dataset.h]; }).sort(function (x, y) { return (+y.dataset.s || 0) - (+x.dataset.s || 0); })[0];
          if (!tpl) continue; used[tpl.dataset.h] = 1; node = tpl.content.firstElementChild && tpl.content.firstElementChild.cloneNode(true);
        } else if (type === 'gifts') {
          node = giftStrip();
        } else {
          var t2 = brkT.filter(function (x) { return x.dataset.brk === type; })[0];
          node = t2 && t2.content.firstElementChild && t2.content.firstElementChild.cloneNode(true);
        }
        if (!node) continue;
        node.setAttribute('data-brk-item', ''); node.classList.add('brk');
        visible[k * per - 1].after(node);
        $$('[data-tilt]', node).concat(node.matches('[data-tilt]') ? [node] : []).forEach(tilt);
      }
      tick();
    }
    function apply() {
      var mode = sortEl ? sortEl.value : 'save';
      var list = sortCards(cards.slice(), mode);
      var shown = 0, visible = [];
      list.forEach(function (c) {
        var on = active === 'all' || c.__g === active; c.hidden = !on;
        if (on) { shown++; visible.push(c); }
        c.classList.toggle('is-more', !expanded && on && visible.length > collapse);
        g.appendChild(c); c.classList.add('is-in');
      });
      if (moreBtn) { moreBtn.parentNode.hidden = expanded || shown <= collapse; moreBtn.firstChild.nodeValue = 'Show all ' + shown + ' deals'; }
      if (countEl) countEl.firstChild.nodeValue = shown + (shown === 1 ? ' deal ' : ' deals ');
      placeBreakers(visible.filter(function (c) { return !c.classList.contains('is-more'); }));
    }
    if (moreBtn) moreBtn.addEventListener('click', function () { expanded = true; apply(); track('show_all'); });
    var rw = W.innerWidth; W.addEventListener('resize', function () { if ((rw <= 820) !== (W.innerWidth <= 820)) { rw = W.innerWidth; apply(); } });
    if (sortEl) sortEl.addEventListener('change', function () { apply(); track('sort', { mode: sortEl.value }); });
    apply();
  })();

  /* ---------- Phone sticky bar ---------- */
  (function () {
    var bar = $('[data-mbar]'); if (!bar) return;
    var first = $('[data-hero]') || $('[data-ch]'), fin = $('[data-fin]') || $('.xs'), past = false, atEnd = false;
    function upd() { bar.classList.toggle('is-on', past && !atEnd); }
    if ('IntersectionObserver' in W) {
      if (first) new IntersectionObserver(function (es) { past = !es[0].isIntersecting; upd(); }).observe(first);
      if (fin) new IntersectionObserver(function (es) { atEnd = es[0].isIntersecting; upd(); }).observe(fin);
    }
  })();

  /* ---------- Start ---------- */
  hero();
  H.classList.add('ff26-go');
  if (heroApi) heroApi.start();
  // Pre-sale VIP SMS sign-up button in the hero
  D.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-presale]')) track('vip_signup_click', {}); });
  track('view', { page: $('[data-hero]') ? 'landing' : ('collection_' + (($('[data-cat]') || {}).dataset || {}).cat) });
})();
